import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { AboutPage } from './pages/About';
import { ContactPage } from './pages/Contact';
import { ReviewsPage } from './pages/Reviews';
import { NotFoundPage } from './pages/NotFound';
import { ServicePage } from './pages/ServicePage';
import { servicePages } from './data/servicePages';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mlu9qp3etrta">
      <Routes data-id="element-1" data-mp="2mmccm4kkv4a6">
        <Route element={<SiteLayout data-id="element-3" data-mp="2mn59mdtqiff4" />} data-id="element-2" data-mp="2mmvl6uoc8gbj">
          <Route path="/" element={<Home data-id="element-5" data-mp="31aqh0jxn70su" />} data-id="element-4" data-mp="2mjpwhgjmfggc" />
          <Route path="/about" element={<AboutPage data-id="element-7" data-mp="31c9w477kb5t1" />} data-id="element-6" data-mp="31ayr642drs0c" />
          <Route path="/contact" element={<ContactPage data-id="element-9" data-mp="2wjgrdjc3fxgy" />} data-id="element-8" data-mp="31cjmvx0flgzs" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-11" data-mp="2whxb3sqftmf6" />} data-id="element-10" data-mp="2wj8dpp85co4p" />
          {servicePages.map(page => <Route key={page.slug} path={`/${page.slug}`} element={<ServicePage page={page} data-id="element-13" data-mp="23vkw8j26adma" />} data-id="element-12" data-mp="28t4ju9krg2qw" />)}
          <Route path="*" element={<NotFoundPage data-id="element-15" data-mp="23ti864kkyuk7" />} data-id="element-14" data-mp="23utadzydnu97" />
        </Route>
      </Routes>
    </BrowserRouter>;
}